import { ListItem, ListItemIcon, ListItemText } from '@mui/material'
import LogoutIcon from '@mui/icons-material/ExitToAppOutlined'
import React from 'react'
import { AnalyticService } from '../../lib/analytics/analyticService'

export default function SchoolLogoutListItem(props: { customStyle?: any }) {
  return (
    <ListItem
      style={props.customStyle ? { ...props.customStyle } : {}}
      onClick={() => {
        localStorage.clear()
        sessionStorage.clear()
        AnalyticService.onSchoolUserLogout()
        window.location.reload()
      }}
      button={true}
    >
      <ListItemIcon style={{ color: 'inherit' }}>
        <LogoutIcon
          // style={{ color: "#fff" }}
          // color="primary"
          fontSize="small"
        />
      </ListItemIcon>
      <ListItemText>Logout</ListItemText>
    </ListItem>
  )
}
